import { $, $$, alcance, aviso, avisoHtml, cajaDelActo, esc, fecha, limpiar, misCajas, noHabilitado, nombreCaja, num, pedir, puede, puedoActo, puedoOperar, repintar, rpc, sb, trabado, trabarSiNoContesto, YO, pedirTodo, ordenarPor } from './nucleo';
import { cargarClientes } from './clientes';
import { ERROR_COTIZ_COBRO, ERROR_MEDIOS, MEDIOS, MONEDAS, MONEDA_CAT, aCatalogo,
         catalogosCobro, desdeCatalogo, frenoCotizacion, frenoMonedas, frenoPlata,
         rotuloMoneda } from './cobros';

// =====================================================================
//  CUENTAS CORRIENTES  (0033, punto 4)
// =====================================================================
//  La deuda no se carga a mano en ningún lado: nace cuando un equipo sale
//  sin estar pagado y baja cuando se cobra o cuando la mercadería vuelve.
//  Esta pantalla mira eso, deja fijar el crédito a quien tiene el permiso,
//  y deja cobrar la cuenta a quien opera una caja.
let CUENTAS = [], CTA_ABIERTA = null;
//  Un ajuste en viaje (0075): el botón no se vuelve a encender al reabrir.
let AJUSTANDO = false;

//  Lo que NO se pudo leer, que no es lo mismo que lo que no hay. Dos banderas
//  porque cierran puertas distintas (regla 11): sin la lista de cuentas no se
//  mira un saldo ni se elige a quién fijarle crédito; sin los movimientos de
//  UNA cuenta, las otras se siguen abriendo y el crédito se sigue fijando.
export let ERROR_CUENTAS = '', ERROR_MOVS = '';
//  Cuántos movimientos de una cuenta se piden. El servidor corta en mil sin
//  avisar (D122): se piden 500 y, si llegan 500, se dice (igual que con los
//  movimientos de un proveedor). El saldo no sale de esta lista: lo suma la base.
const TOPE_MOVS_CC = 500;
//  Lo que impide fijar un crédito, o ''. Se guarda porque lo miran DOS lugares
//  (el botón y el `submit`) y tienen que dar la misma respuesta: si el submit
//  recalcula, sin permiso de ver clientes culpa a la persona de "no elegir".
let FRENO_CREDITO = '';

// ---------------------------------------------------------------------
//  Las dos preguntas que hay que hacer ANTES de mostrar un número
// ---------------------------------------------------------------------
//  Ver la CONDICIÓN de cuenta corriente y ver el SALDO son dos permisos
//  distintos, y la pestaña la abre `cliente.ver_saldo` **o**
//  `cliente.limite_credito` (arranque.ts, el "A o B" de la D84): se puede
//  entrar sin el primero.
//
//  Ver D83. `v_cuenta_corriente` suma el saldo de un LEFT JOIN a
//  `cc_movimientos`, cuyo RLS es
//  `puede('cliente','ver_saldo') and cliente_id in (select app.mis_clientes())`
//  (`app.cliente_es_mio`, lista desde la 0058). Sin el permiso el join no
//  trae nada y el `coalesce(…, 0)` **de la vista** lo vuelve cero: 200, sin
//  error, y un cero que se lee como "no debe nada". **Ninguna bandera del
//  front puede ver eso**: la única forma es preguntar el permiso antes (la
//  regla del 4/9) y mostrar que no se puede ver.
const veSaldo = () => puede('cliente','ver_saldo');
const SIN_SALDO = 'no lo podés ver';
const chipTapado = () => `<span class="chip c-warn">${SIN_SALDO}</span>`;

//  El alcance de lo que la pantalla LISTA, otra pregunta (D85). Las filas de
//  `v_cuenta_corriente` salen de `clientes`, cuyo RLS es
//  `id in (select app.mis_clientes())` (0058) y mira el alcance de
//  `cliente.ver`, no el de saldos ni el de crédito. Con `propio` la lista
//  llega recortada: lo que no se puede afirmar es el caso vacío.
const vistoPorMi = () => alcance('cliente','ver') === 'propio' ? ' visible para vos' : '';

//  La TERCERA pregunta, la que abre la lista entera. Sin `cliente.ver`,
//  `app.cliente_es_mio()` casi siempre da false: la vista PUEDE contestar cero
//  filas con `error: null`, y la pantalla diría "Todavía no hay cuentas". Se puede
//  entrar sin ese permiso (D84: el permiso que ABRE no es el que deja LEER).
//
//  **Pero la consulta se emite igual**: `app.cliente_es_mio` tiene CUATRO
//  caminos (también `es_admin()` y el cliente con un pedido de mi vuelta).
//  Saltear la lectura escondería filas a quien sí las ve (regla 11); como en
//  `v_vueltas` y `v_vuelta_paradas`, no se condiciona la lectura sino el texto
//  del vacío.
const veClientes = () => puede('cliente','ver');

export async function cargarCuentas(){
  //  El pago a cuenta entra en la caja de `cc.caja`, y anular un pago exige la
  //  habilitación de la caja del movimiento. Lo contesta la base (D93).
  await Promise.all([catalogosCobro(), misCajas()]);
  //  Con `config` ilegible no se sabe la moneda: poner "USD" (el respaldo) sería
  //  afirmarlo sin haberlo leído.
  $('#ccMonedaTit').textContent = rotuloMoneda();
  $$('.ccMonedaAj').forEach(b => { b.textContent = rotuloMoneda(); });

  //  `vendedor_id` lo necesita el select del crédito: el alcance de
  //  `cliente.limite_credito` se mide contra el vendedor del cliente (D74).
  //  Ojo: no escribir un `try/catch` a mano. Con la red caída la librería
  //  CONTESTA (`status: 0`) en vez de rechazar (D92); `pedir()` cubre ambos
  //  casos y es el único lugar donde está escrito (D88, D90).
  const { data, error } = await pedirTodo(() => sb.from('v_cuenta_corriente')
    .select('cliente_id,nombre,es_cc,sin_tope,limite,saldo,disponible,ultimo_movimiento,vendedor_id,credito_actualizado_por,credito_actualizado_en')
    , { por: 'cliente_id', orden: ordenarPor('nombre', 'cliente_id') });
  //  La bandera ANTES de cualquier `return` y la lista vaciada: dejar la de la
  //  vez anterior la mostraría como si fuera la de ahora.
  ERROR_CUENTAS = error ? error.message : '';
  CUENTAS = error ? [] : (data || []);
  //  El `else limpiar` es necesario: `cargarCuentas` corre en cada entrada y
  //  el cartel de error anterior quedaría pegado.
  if (error) avisoHtml('#ctaMsg','bad',
    'No se pudieron leer las cuentas (' + esc(error.message) + '). Lo que se ve ' +
    'abajo no es la lista de cuentas: es que no se pudo leer. Se reintenta ' +
    'volviendo a entrar a la pestaña.');
  else limpiar('#ctaMsg');

  if (puede('cliente','limite_credito')) pintarSelectCredito();
  pintarCuentas();
  if (CTA_ABIERTA) abrirCuenta(CTA_ABIERTA, true);
  if (IR_A_CUENTA){ IR_A_CUENTA = false; $('#cardMovsCC').scrollIntoView({ block: 'start' }); }
}

function pintarCuentas(){
  //  El cartel del permiso que deja ver la lista, en su propio div (otra
  //  causa). No dice "no podés ver ninguna": el RLS de `clientes` tiene otros
  //  caminos, así que no se puede afirmar cuántas hay.
  if (!veClientes())
    avisoHtml('#ctaVerMsg','bad',
      'No tenés el permiso <b>cliente.ver</b>, que es el que deja leer la lista de ' +
      'clientes. Acá sólo pueden aparecer los clientes que la base te deja ver por ' +
      'otro camino —los de una vuelta tuya, por ejemplo—, así que una lista corta o ' +
      'vacía <b>no quiere decir que no haya clientes</b>. Y ojo, que la base tampoco ' +
      'contesta un error acá: contesta una lista vacía, que se ve igual que «todavía ' +
      'no hay ninguna cuenta cargada».');
  else limpiar('#ctaVerMsg');

  //  El cartel del permiso de los saldos, una sola vez arriba: la causa arriba,
  //  el efecto en cada fila.
  //
  //  Sólo cuando la lista se pudo leer: afirma que la base "devuelve la lista
  //  completa" y que el límite "sí son datos leídos", falso para quien entró
  //  con `cliente.limite_credito` a secas (no llega ninguna fila). La bandera
  //  tiene que llegar a lo que ROTULA, no sólo a lo que FRENA.
  //  Sin `cliente.ver` la lista igual puede traer filas (la cuarta rama de
  //  `app.cliente_es_mio`, 141): el cero está ahí también, pero la lista no es
  //  «la completa» (sesión 97).
  if (!veSaldo() && veClientes())
    avisoHtml('#ctaSaldoMsg','bad',
      'No tenés el permiso <b>cliente.ver_saldo</b>, así que lo que cada cliente ' +
      'debe y lo que le queda de cupo <b>no se pueden mostrar</b>. Ojo con esto: ' +
      'la base no contesta un error — devuelve la lista completa con los saldos ' +
      'en <b>cero</b>, y un cero acá se leería como «no debe nada». La condición ' +
      'de cuenta corriente y el límite sí son datos leídos.');
  else if (!veSaldo() && !ERROR_CUENTAS && CUENTAS.length)
    avisoHtml('#ctaSaldoMsg','bad',
      'No tenés el permiso <b>cliente.ver_saldo</b>, así que lo que cada cliente ' +
      'debe y lo que le queda de cupo <b>no se pueden mostrar</b>. Ojo con esto: ' +
      'la base no contesta un error — devuelve los clientes que te deja ver con ' +
      'los saldos en <b>cero</b>, y un cero acá se leería como «no debe nada». La ' +
      'condición de cuenta corriente y el límite sí son datos leídos.');
  else limpiar('#ctaSaldoMsg');

  const q = ($('#buscaCta')?.value || '').toLowerCase();
  //  El filtro de los que deben es una pregunta sobre el saldo: sin el permiso
  //  (o con la lista ilegible) contestarla con el cero de la vista diría "no
  //  hay nadie debiendo". Se apaga y se dice por qué (regla 16).
  const puedeFiltrar = veSaldo() && !ERROR_CUENTAS;
  $('#ctaSoloDeben').disabled = !puedeFiltrar;
  $('#ctaFiltroMsg').textContent = puedeFiltrar ? ''
    : !veSaldo() ? 'no podés ver los saldos, así que no se puede filtrar por deuda'
                 : 'sin la lista no se puede filtrar por deuda';
  const soloDeben = puedeFiltrar && $('#ctaSoloDeben')?.checked;

  const f = CUENTAS.filter(c =>
    (!q || c.nombre.toLowerCase().includes(q)) &&
    (!soloDeben || Number(c.saldo) > 0.005));

  const tapado = !veSaldo();
  $('#tblCuentas').innerHTML = f.map(c => {
    const debe = Number(c.saldo || 0);
    //  "debe y no es de cuenta" habla del SALDO: con el saldo tapado no aparece
    //  porque lo apaga el cero de la vista, sin condición propia. Ojo: no
    //  agregar un `!tapado &&`; ninguna prueba lo distingue de su ausencia
    //  (`Number(null || 0)` también es cero). Lo cuida la prueba de la CELDA.
    //  `es_cc`, `sin_tope` y `limite` son columnas de `clientes`: esos chips
    //  se siguen mostrando.
    const situacion = !c.es_cc
      ? (debe > 0.005
          ? '<span class="chip c-bad">debe y no es de cuenta</span>'
          : '<span class="chip">paga al recibir</span>')
      : c.sin_tope ? '<span class="chip c-warn">sin tope</span>'
      : Number(c.limite) === 0 ? '<span class="chip c-warn">sin límite asignado</span>'
      : '<span class="chip c-ok">cuenta corriente</span>';
    //  Le queda: rojo si se pasó, ámbar si queda poco. Sólo vale si el cliente
    //  fía; con el saldo tapado no se calcula (`disponible` sería el límite
    //  entero). Sin `tapado` adelante a propósito: esta rama no se alcanza con
    //  el saldo tapado (regla 23, el corolario).
    const disp = (!c.es_cc || c.sin_tope) ? null : Number(c.disponible);
    const clase = disp === null ? '' : disp < 0 ? 'c-bad' : disp === 0 ? 'c-warn' : 'c-ok';
    return `<tr data-cta="${c.cliente_id}" style="cursor:pointer">
      <td><b>${esc(c.nombre)}</b></td>
      <td>${situacion}</td>
      <td class="num">${c.es_cc && !c.sin_tope ? num(Number(c.limite)) : '—'}</td>
      <td class="num">${tapado ? chipTapado()
          : debe > 0.005 ? `<b>${num(debe)}</b>`
          //  (0075, D186) Un ajuste puede dejar la cuenta a favor del cliente:
          //  un «—» diría que no hay nada.
          : debe < -0.005 ? `<span class="hint">a favor ${num(-debe)}</span>` : '—'}</td>
      <td class="num">${
          //  El recorte tan fino como el dato (regla 23): con el saldo tapado
          //  sólo no se puede decir un NÚMERO; "sin cupo" y "sin tope" son
          //  datos de `clientes` que sí se leyeron.
          tapado
          ? (!c.es_cc ? '—'
             : c.sin_tope ? '<span class="chip c-warn">sin tope</span>'
             : chipTapado())
          : disp !== null
          ? `<span class="chip ${clase}">${num(disp)}</span>`
          : c.sin_tope ? '<span class="chip c-warn">sin tope</span>' : '—'}</td>
      <td class="mono">${tapado ? chipTapado()
          : c.ultimo_movimiento
          ? esc(new Date(c.ultimo_movimiento).toLocaleString('es-AR')) : '—'}</td></tr>`;
  }).join('') || `<tr><td colspan="6" class="vacio">${
      //  Los CINCO casos vacíos, distintos: no se pudo leer, no lo podés ver,
      //  nada coincide con el filtro, no hay nadie debiendo y no hay cuentas
      //  (los dos últimos con el sufijo del alcance, D85). El del filtro es
      //  necesario: decir "no hay cuentas" sobre datos leídos sería falso.
      ERROR_CUENTAS ? 'No se pudieron leer las cuentas'
      : !veClientes() ? 'No hay ninguna cuenta que puedas ver: te falta el permiso de ver clientes'
      : q ? 'Nada con ese filtro'
      : soloDeben ? 'No hay nadie debiendo' + vistoPorMi()
      : 'Todavía no hay cuentas para mostrar' + vistoPorMi()}</td></tr>`;

  $$('[data-cta]', $('#tblCuentas')).forEach(tr =>
    tr.onclick = () => abrirCuenta(Number(tr.dataset.cta)));
}

$('#buscaCta').oninput   = pintarCuentas;
$('#ctaSoloDeben').onchange = pintarCuentas;

//  IR A LA CUENTA DE UN CLIENTE desde su ficha (D218): deja la cuenta como la
//  abierta y aprieta la pestaña verdadera; `cargarCuentas` la abre al terminar
//  de leer (como cuando se vuelve a entrar con una abierta).
let IR_A_CUENTA = false;
export function irACuenta(clienteId: number){
  CTA_ABIERTA = clienteId;
  IR_A_CUENTA = true;
  $('#tabCuentas').click();
}

async function abrirCuenta(clienteId, silencioso?){
  CTA_ABIERTA = clienteId;
  //  Ojo: la tarjeta se destapa ANTES de cualquier `return`; `#movsMsg` vive
  //  ADENTRO de `#cardMovsCC` y avisar con la tarjeta oculta no muestra nada.
  $('#cardMovsCC').classList.remove('oculto');
  if (!silencioso) limpiar('#movsMsg');
  //  El panel de pago arranca cerrado: lo destapa el final de esta función; un
  //  `return` anterior significa que no hay saldo con el que ofrecer cobrar.
  $('#formPagoCC').classList.add('oculto');
  //  El de ajustar, igual: se destapa apenas se sabe de qué cuenta se trata.
  $('#formAjusteCC').classList.add('oculto');
  if (!silencioso){
    limpiar('#ccaMsg');
    $('#ccaMonto').value = ''; $('#ccaMotivo').value = ''; $('#ccaBaja').checked = true;
  }

  const c = CUENTAS.find(x => x.cliente_id === clienteId);
  if (!c){
    $('#movsTit').textContent = 'Movimientos';
    $('#tblMovsCC').innerHTML =
      '<tr><td colspan="7" class="vacio">No se pudo leer esta cuenta</td></tr>';
    aviso('#movsMsg','bad', ERROR_CUENTAS
      ? 'Esta cuenta no está en la lista porque las cuentas no se pudieron leer (' +
        ERROR_CUENTAS + ').'
      : 'Esa cuenta ya no está en la lista.');
    return;
  }

  //  AJUSTAR LA CUENTA (0075, D186), ANTES de los dos `return` de abajo (el del
  //  saldo tapado y el de «no hay nada que cobrar»): el caso del primer día es
  //  justo un cliente que todavía no debe nada. Con el saldo tapado se ofrece
  //  igual: es un acto, no un dato.
  $('#formAjusteCC').classList.toggle('oculto', !puede('cliente','ajustar_cuenta'));
  $('#ccaOk').disabled = trabado('#ccaOk') || AJUSTANDO;

  const debe = Number(c.saldo || 0);
  const tapado = !veSaldo();
  $('#movsTit').innerHTML = `Cuenta de ${esc(c.nombre)} — ` +
    (tapado ? `lo que debe ${chipTapado()}`
     : debe > 0.005 ? `debe <b>${num(debe)} ${esc(rotuloMoneda())}</b>`
     : debe < -0.005 ? `a favor del cliente por <b>${num(-debe)} ${esc(rotuloMoneda())}</b>`
                    : 'sin deuda') +
    (c.es_cc && !c.sin_tope
      ? ` de un límite de ${num(Number(c.limite))} ${esc(rotuloMoneda())}` : '') +
    (c.credito_actualizado_por
      ? ` <span class="hint">· crédito fijado por ${esc(c.credito_actualizado_por)}` +
        (c.credito_actualizado_en ? ` el ${esc(fecha(c.credito_actualizado_en))}` : '') +
        '</span>' : '');

  //  Los movimientos los tapa el MISMO permiso que los saldos, con lista vacía:
  //  "no tiene movimientos" sobre una cuenta que puede deber es mentira. Se
  //  pregunta el permiso ANTES de consultar (la regla del 4/9): la consulta
  //  no se emite.
  if (tapado){
    $('#tblMovsCC').innerHTML = '<tr><td colspan="7" class="vacio">' +
      'No podés ver los movimientos de una cuenta</td></tr>';
    avisoHtml('#movsMsg','bad',
      'Lo que se movió en esta cuenta lo deja leer <b>cliente.ver_saldo</b>, que no ' +
      'tenés. No es que no tenga movimientos: es que no se pueden leer. Y sin saber ' +
      'cuánto debe, tampoco se puede registrar un pago a cuenta.');
    return;
  }

  //  Mismo envoltorio `pedir()` que arriba (rechazo y red caída).
  const { data, error } = await pedir(sb.from('v_cc_movimientos')
    .select('id,tipo,monto,motivo,pedido,referencia_tipo,moneda,monto_origen,medio_pago,caja,caja_id,revierte_a,anulado_por,usuario,ocurrido_en')
    .eq('cliente_id', clienteId).order('id', { ascending: false }).limit(TOPE_MOVS_CC));
  //  Guarda de la carrera: dos clicks seguidos pueden volver en cualquier
  //  orden y pintar movimientos bajo el título del otro, con "Anular" atado a
  //  ids equivocados (es plata). El mock es sincrónico: sin prueba ni sabotaje.
  if (CTA_ABIERTA !== clienteId) return;
  const habiaError = !!ERROR_MOVS;
  ERROR_MOVS = error ? error.message : '';
  if (error) avisoHtml('#movsMsg','bad',
    'No se pudieron leer los movimientos de esta cuenta (' + esc(error.message) + '). ' +
    'Lo de abajo no es lo que se movió: es que no se pudo leer. Se reintenta ' +
    'volviendo a hacer click en el cliente.');
  //  El `else limpiar` es necesario: la relectura silenciosa de
  //  `cargarCuentas` no limpia el cartel, sólo el click. Pero borra SÓLO el
  //  cartel de la lectura caída (sesión 121): la relectura que sigue a un pago
  //  o a una anulación vuelve DESPUÉS de que se avisó el resultado, y se lo
  //  llevaba (el «Cobrado …» duraba un instante).
  else if (habiaError) limpiar('#movsMsg');

  //  Dos columnas de un LEFT JOIN que un permiso deja en null sin fallo (D84):
  //  la caja (`caja.ver`) y el código del pedido (alcance de `pedido.ver`). Un
  //  hueco callado diría "no entró a ninguna caja" / "no es de ningún pedido".
  //  El null por permiso se distingue del real con el dato que SÍ llegó:
  //  `referencia_tipo` implica un pedido, y una moneda implica una caja.
  const veCaja = puede('caja','ver');
  //  El del pedido se PREGUNTA: con alcance `todos`, un código null es otra
  //  cosa (referencia colgada) y no se afirma nada. Ojo: `puede()` no alcanza;
  //  con `propio` la consulta trae filas y el recorte es invisible (D85).
  const vePedidos = alcance('pedido','ver') === 'todos';
  const nombreTipo = { cargo:'Cargo', pago:'Pago', ajuste:'Ajuste', nota_credito:'Nota de crédito' };
  $('#tblMovsCC').innerHTML = (data||[]).map(m => {
    const monto = Number(m.monto);
    const anulado = m.anulado_por != null;
    const esReversa = m.revierte_a != null;
    return `<tr${anulado || esReversa ? ' style="opacity:.6"' : ''}>
      <td class="mono">${esc(new Date(m.ocurrido_en).toLocaleString('es-AR'))}</td>
      <td>${esc(nombreTipo[m.tipo] || m.tipo)}${
          anulado ? ' <span class="chip c-bad">anulado</span>' : ''}${
          esReversa ? ' <span class="chip">anulación</span>' : ''}</td>
      <td class="num"><b>${monto > 0 ? '+' : ''}${num(monto)}</b></td>
      <td>${esc(m.motivo || '—')}${
          m.pedido ? ` <span class="chip">${esc(m.pedido)}</span>`
          : m.referencia_tipo === 'pedido' && !vePedidos
            ? ' <span class="chip c-warn">de un pedido que no podés ver</span>' : ''}</td>
      <td>${m.moneda ? `${m.medio_pago ? esc(m.medio_pago) + ' ' : ''}${esc(m.moneda)} ${
            //  `num()` convierte el null en un cero, y un cero acá diría que
            //  entró plata por cero pesos (regla 14).
            m.monto_origen == null ? '(no se sabe cuánto)' : num(Number(m.monto_origen))}` +
            (m.caja ? ` <span class="hint">→ ${esc(m.caja)}</span>`
             : veCaja ? ''
             : ' <span class="chip c-warn">no podés ver a qué caja entró</span>') : '—'}</td>
      <td>${esc(m.usuario || '—')}</td>
      <td>${m.tipo !== 'pago' || anulado || !puede('caja','operar') ? ''
            //  `anular_pago_cc` exige estar habilitado en la caja del pago (0031;
            //  la vista trae el número desde la 0045). Un null no es "no te
            //  dejan": se ofrece y contesta la base.
            : puedoOperar(m.caja_id) !== false
            ? `<button class="b b-sec" data-anpago="${m.id}">Anular</button>`
            //  El nombre sale de `mis_cajas` si el de la vista no llegó (lo
            //  normal: `cliente.ver_saldo` no es `caja.ver`).
            : `<span class="hint">${
                noHabilitado(m.caja ?? nombreCaja(m.caja_id), 'anular un pago de')}</span>`}</td></tr>`;
  }).join('') + ((data || []).length >= TOPE_MOVS_CC
      ? `<tr><td colspan="7" class="hint">Se muestran los ${num(TOPE_MOVS_CC)} movimientos más nuevos: `
        + 'puede haber más, más viejos. El saldo de arriba es el de todos: lo suma la base.</td></tr>'
      : '') || `<tr><td colspan="7" class="vacio">${
      ERROR_MOVS ? 'No se pudieron leer los movimientos'
                 : 'Esta cuenta no tiene movimientos'}</td></tr>`;

  $$('[data-anpago]', $('#tblMovsCC')).forEach(b =>
    b.onclick = () => anularPagoCC(Number(b.dataset.anpago), c.nombre));

  //  Cobrar es cosa de quien opera una caja y sólo si hay algo que cobrar (acá
  //  `debe` ya es un número leído). Además la habilitación de la caja `cc.caja`
  //  (D48, D93): sólo con un `false` se oculta; null es "no se sabe" y se ofrece.
  const ccMia = puedoActo('cc') !== false;
  const cobrable = puede('caja','operar') && debe > 0.005 && ccMia;
  $('#formPagoCC').classList.toggle('oculto', !cobrable);
  if (!cobrable){
    //  No se pisa el cartel de la lectura caída, que es más grave.
    if (puede('caja','operar') && debe > 0.005 && !ccMia && !ERROR_MOVS)
      avisoHtml('#movsMsg','warn', noHabilitado(cajaDelActo('cc'), 'cobrar en') +
        ' El pago a cuenta entra siempre en esa caja, así que lo tiene que ' +
        'registrar alguien habilitado en ella.');
    return;
  }

  //  Los selects DICEN cuando la lectura se cayó: uno vacío es una afirmación.
  //  Cada uno dice lo que falló EN ÉL (con los medios ilegibles, el de monedas
  //  se leyó bien). `repintar()` y no `innerHTML` (regla 12): la cuenta se
  //  reabre sola y el cajero no pierde lo elegido.
  const freno = frenoPlata();
  repintar('#pcMedio', ERROR_MEDIOS
    ? '<option value="">no se pudieron leer los medios de pago</option>'
    : MEDIOS.map(m => `<option value="${m.id}">${esc(m.nombre)}</option>`).join(''));
  repintar('#pcMoneda', frenoMonedas()
    ? '<option value="">no se pudieron leer las monedas</option>'
    : MONEDAS.map(m =>
      `<option value="${m.id}" data-cod="${esc(m.codigo)}"${
        m.codigo === MONEDA_CAT ? ' selected' : ''}>${esc(m.codigo)}</option>`).join(''));
  $('#pcMonto').value = '';
  $('#pcMotivo').value = '';
  //  La puerta, donde está el acto: sin los catálogos mandaría `Number('')` (NaN).
  $('#pcOk').disabled = !!freno || trabado('#pcOk');
  if (freno)
    avisoHtml('#pcCatMsg','bad', freno + '<br>Mientras tanto no se puede registrar ' +
      'un pago a cuenta: la plata que entra se guarda con su medio, su moneda y su ' +
      'cotización. El pago no se pierde: se registra cuando esto se lea.');
  else limpiar('#pcCatMsg');
  prellenarPago(debe);
}

function codPago(){ return $('#pcMoneda').selectedOptions[0]?.dataset.cod || MONEDA_CAT; }

function prellenarPago(debe){
  //  Bajo freno no se prellena nada: `codPago()` cae a `MONEDA_CAT`, que con
  //  `config` ilegible es la suposición 'USD'.
  const v = frenoPlata() ? null : desdeCatalogo(debe, codPago());
  $('#pcMonto').value = v === null ? '' : String(v);
  equivPago(debe);
}

function equivPago(debe){
  const cod = codPago();
  const monto = Number($('#pcMonto').value);
  const eq = aCatalogo(monto, cod);
  //  La misma puerta que en el panel de cobro: en la moneda de catálogo no
  //  hace falta cotización; en otra sí, y sin ella la base rechaza. Si falló la
  //  lectura no se dice "sin cotización".
  const cot = frenoCotizacion(cod);
  if (!frenoPlata()) $('#pcOk').disabled = !!cot || trabado('#pcOk');
  if (cot) avisoHtml('#pcCotMsg','bad', cot);
  else limpiar('#pcCotMsg');
  $('#pcEquiv').innerHTML = (!monto || cot) ? ''
    : (eq === null
        //  Como en el panel de cobro: no poder LEER la cotización y que no HAYA
        //  ninguna son dos cosas, y sólo la segunda hace rechazar el pago.
        ? (ERROR_COTIZ_COBRO
            ? `<span class="chip c-warn">No se pudieron leer las cotizaciones, así que no se puede mostrar el equivalente. El pago en ${esc(cod)} entra igual.</span>`
            : `<span class="chip c-bad">No hay cotización de ${esc(cod)} cargada: la base va a rechazar el pago.</span>`)
        : `Equivale a <b>${num(eq)} ${esc(rotuloMoneda())}</b>` +
          (eq > debe + 0.005
            ? ` — <span class="chip c-bad">es más de lo que debe (${num(debe)})</span>` : ''));
}

$('#pcMoneda').onchange = () => {
  const c = CUENTAS.find(x => x.cliente_id === CTA_ABIERTA);
  prellenarPago(Number(c?.saldo || 0));
};
$('#pcMonto').oninput = () => {
  const c = CUENTAS.find(x => x.cliente_id === CTA_ABIERTA);
  equivPago(Number(c?.saldo || 0));
};
$('#pcCerrar').onclick = () => {
  $('#cardMovsCC').classList.add('oculto');
  CTA_ABIERTA = null;
};

//  «Ajustar la cuenta» (0075, D186): la regla de `#pvaOk` de Proveedores.
$('#ccaOk').onclick = async () => {
  limpiar('#ccaMsg');
  const cuenta = CTA_ABIERTA;
  if (cuenta == null){ aviso('#ctaMsg','bad','Esa cuenta ya no está abierta.'); return; }
  const monto = Number($('#ccaMonto').value);
  if (!(monto > 0)){ aviso('#ccaMsg','bad','Poné de cuánto es el ajuste.'); return; }
  const motivo = ($('#ccaMotivo').value || '').trim();
  if (!motivo){
    aviso('#ccaMsg','bad','Escribí de qué es el ajuste: sin motivo no sirve para nada, y la base no lo deja.');
    return;
  }
  //  El signo lo pone la pantalla y no la persona: «baja la deuda» es un monto
  //  negativo, y un menos a mano es fácil de errar.
  const conSigno = $('#ccaSube').checked ? monto : -monto;
  const btn = $('#ccaOk');
  AJUSTANDO = true;
  btn.disabled = true;
  const { data, error } = await rpc('ajustar_cuenta_cliente', {
    p_cliente_id: cuenta, p_monto: conSigno, p_motivo: motivo });
  AJUSTANDO = false;
  //  Un ajuste que no contestó quizá quedó hecho: el botón no vuelve (D91, D92).
  trabarSiNoContesto('#ccaOk', error);
  if (!trabado('#ccaOk')) btn.disabled = false;
  if (error){ aviso(CTA_ABIERTA === cuenta ? '#ccaMsg' : '#ctaMsg','bad', error.message); return; }
  //  Lo escrito se borra sólo si sigue siendo de ESA cuenta.
  if (CTA_ABIERTA === cuenta){ $('#ccaMonto').value = ''; $('#ccaMotivo').value = ''; }
  await cargarCuentas();
  aviso(CTA_ABIERTA === cuenta ? '#ccaMsg' : '#ctaMsg','ok', data?.mensaje ?? 'El ajuste quedó registrado.');
};

$('#pcOk').onclick = async () => {
  limpiar('#movsMsg');
  const monto = Number($('#pcMonto').value);
  if (!(monto > 0)){ aviso('#movsMsg','bad','Poné cuánto está pagando.'); return; }
  $('#pcOk').disabled = true;
  const { data, error } = await rpc('registrar_pago_cc', {
    p_cliente_id   : CTA_ABIERTA,
    p_medio_pago_id: Number($('#pcMedio').value),
    p_moneda_id    : Number($('#pcMoneda').value),
    p_monto        : monto,
    p_motivo       : $('#pcMotivo').value.trim() || null
  });
  //  Si la base no contestó, el pago quizá quedó registrado: el botón no
  //  vuelve hasta que se entre de nuevo a la pestaña (D91, D92).
  $('#pcOk').disabled = false;
  trabarSiNoContesto('#pcOk', error);
  if (error){ aviso('#movsMsg','bad', error.message); return; }
  await cargarCuentas();
  //  `data` es nulable: un `data.mensaje` tiraría TypeError DESPUÉS de registrar
  //  el pago e invitaría a cobrar de nuevo.
  aviso('#movsMsg','ok', data?.mensaje ?? 'El pago quedó registrado.');
};

async function anularPagoCC(id, nombre){
  const motivo = prompt(`Anular el pago de ${nombre}. ¿Por qué? Es plata: queda escrito.`);
  if (motivo === null) return;
  limpiar('#movsMsg');
  const { data, error } = await rpc('anular_pago_cc',
    { p_movimiento_id: id, p_motivo: motivo });
  if (error){ aviso('#movsMsg','bad', error.message); return; }
  await cargarCuentas();
  aviso('#movsMsg','ok', data?.mensaje ?? 'El pago quedó anulado.');
}

// ---------- fijar el crédito ----------
//  El select de a quién. Tres cosas:
//  · Con la lista de cuentas ilegible no se ofrece elegir: un `<select>` vacío
//    es una afirmación (12/9) y "Guardar" mandaría `Number('')` (un cero).
//  · El ALCANCE de `cliente.limite_credito` no es el de `cliente.ver` (D74):
//    `public.fijar_credito` llama a `app.exigir_alcance('cliente',
//    'limite_credito', <vendedor del cliente>)`; con `propio` ese vendedor
//    tiene que ser yo (sin vendedor también rebota). La lista llegó filtrada
//    por `cliente.ver`: ofrecer clientes ajenos es un formulario que la base
//    rechaza.
//  · `repintar()` y no `innerHTML` (regla 12): no se pierde el cliente elegido.
function pintarSelectCredito(){
  const propio = alcance('cliente','limite_credito') === 'propio';
  const mios = propio ? CUENTAS.filter(c => c.vendedor_id === YO.id) : CUENTAS;
  //  Tres ramas: un `<select>` sin ninguna `<option>` es la forma más muda de
  //  la misma afirmación (12/9).
  repintar('#crCliente', ERROR_CUENTAS
    ? '<option value="">no se pudo leer la lista de clientes</option>'
    : !mios.length
      ? `<option value="">${veClientes() || CUENTAS.length ? 'no hay ningún cliente para elegir'
                                         : 'no podés ver la lista de clientes'}</option>`
    : mios.map(c => `<option value="${c.cliente_id}">${esc(c.nombre)}</option>`).join(''));

  const freno = FRENO_CREDITO = ERROR_CUENTAS
    ? 'No se pudo leer la lista de clientes (' + esc(ERROR_CUENTAS) + '), así que no ' +
      'se puede fijar el crédito de nadie: hay que saber a quién. Se reintenta ' +
      'volviendo a entrar a la pestaña.'
    //  Sin `cliente.ver` la lista igual puede traer clientes (la cuarta rama de
    //  `app.cliente_es_mio`: los de una vuelta mía), y `fijar_credito` no pide
    //  ese permiso: con filas NO se frena (141, sesión 97). Sólo sin ninguna.
    : !CUENTAS.length && !veClientes()
      ? 'Tenés el permiso de fijar el crédito, pero no el de <b>ver la lista de ' +
        'clientes</b>, así que no hay a quién elegir. No es que no haya clientes: ' +
        'son dos permisos distintos y falta el segundo.'
    : !mios.length
      ? (propio
          ? 'No hay ningún cliente <b>tuyo</b> en la lista. Tu permiso de crédito es ' +
            'sólo sobre los clientes que tenés asignados, así que no hay a quién ' +
            'fijárselo.'
          : 'Todavía no hay ningún cliente' + vistoPorMi() + ', así que no hay a ' +
            'quién fijarle un crédito.')
      : '';
  //  La puerta también en el botón, pero la de verdad está en el `submit`
  //  (un botón apagado no frena el Enter).
  $('#crGuardar').disabled = !!freno;
  if (freno){
    avisoHtml('#crCatMsg','bad', freno);
    //  El formulario no conserva el cliente de la vez anterior: mostraría datos
    //  de una fila que ya no está.
    limpiar('#crEstado');
    $('#crEsCC').checked    = false;
    $('#crSinTope').checked = false;
    $('#crLimite').value    = '';
    $('#crLimite').disabled = true;
  }
  else {
    //  Con filas y sin `cliente.ver`: se puede elegir, pero la lista no es «todos
    //  los clientes». Se dice sin frenar.
    if (!veClientes())
      avisoHtml('#crCatMsg','warn',
        'No tenés el permiso de <b>ver la lista de clientes</b>: acá aparecen sólo ' +
        'los que la base te deja ver por otro camino —los de una vuelta tuya, por ' +
        'ejemplo—. Puede haber otros clientes que no ves.');
    else limpiar('#crCatMsg');
    reflejarCredito();
  }
}

//  El formulario arranca con lo que el cliente tiene hoy: guardar sin tocar
//  nada no cambia nada.
function reflejarCredito(){
  const c = CUENTAS.find(x => x.cliente_id === Number($('#crCliente').value));
  if (!c) return;
  $('#crEsCC').checked    = c.es_cc;
  $('#crSinTope').checked = c.sin_tope;
  $('#crLimite').value    = c.es_cc ? String(Number(c.limite)) : '';
  $('#crMotivo').value    = '';
  const debe = Number(c.saldo || 0);
  //  Saldo tapado otra vez: esta frase es la que más invita a decidir; un
  //  "Hoy no debe nada" sobre un cero no leído hace subir el cupo por error.
  const tapado = !veSaldo();
  $('#crEstado').innerHTML = tapado
    ? (!c.es_cc
        ? `Hoy ${esc(c.nombre)} paga al recibir.`
        : `Hoy ${esc(c.nombre)} es cliente de cuenta corriente` +
          (c.sin_tope ? ' y no tiene tope.'
                      : ` con un límite de ${num(Number(c.limite))} ${esc(rotuloMoneda())}.`)) +
      ` <span class="chip c-warn">Lo que debe hoy, ${SIN_SALDO}</span>`
    : !c.es_cc
    ? `Hoy ${esc(c.nombre)} paga al recibir.` +
      (debe > 0.005 ? ` <span class="chip c-bad">Debe ${num(debe)} ${esc(rotuloMoneda())}</span>` : '')
    : (debe > 0.005
        ? `Hoy debe <b>${num(debe)} ${esc(rotuloMoneda())}</b>` +
          (c.sin_tope ? ' y no tiene tope.' : ` de un límite de ${num(Number(c.limite))}.`)
        : c.sin_tope ? 'Hoy no debe nada y no tiene tope.'
        : Number(c.limite) === 0
          ? 'Hoy no debe nada, y con el límite en 0 no se le fía: ponele un número.'
          : `Hoy no debe nada y tiene ${num(Number(c.limite))} ${esc(rotuloMoneda())} de límite.`);
  //  Sin tope y un número no conviven: el número deja de querer decir algo.
  $('#crLimite').disabled = $('#crSinTope').checked || !$('#crEsCC').checked;
}
$('#crCliente').onchange = reflejarCredito;
$('#crEsCC').onchange    = () => { $('#crLimite').disabled = !$('#crEsCC').checked || $('#crSinTope').checked; };
$('#crSinTope').onchange = () => { $('#crLimite').disabled = $('#crSinTope').checked || !$('#crEsCC').checked; };

$('#formCred').onsubmit = async e => {
  e.preventDefault();
  limpiar('#credMsg');
  //  La puerta adentro de la función (el botón apagado no frena el Enter). Aporta
  //  sobre todo el TEXTO: un `if (!id)` también cortaría, pero diría "Elegí a
  //  qué cliente" culpando a la persona cuando falló una lectura o falta un
  //  permiso. Se repite el cartel del formulario.
  if (FRENO_CREDITO){ avisoHtml('#credMsg','bad', FRENO_CREDITO); return; }
  //  Ojo: NO va un `if (!id)`; el freno de arriba tapa los tres casos sin id
  //  válido y la guarda no se distingue de su ausencia (regla del 13/9). Si el
  //  select puede quedar sin valor sin freno, vuelve, con su prueba.
  const id = Number($('#crCliente').value);
  const esCC = $('#crEsCC').checked;
  const lim  = $('#crLimite').value;
  const { data, error } = await rpc('fijar_credito', {
    p_cliente_id: id,
    p_es_cc     : esCC,
    p_limite    : esCC && lim !== '' ? Number(lim) : null,
    p_sin_tope  : $('#crSinTope').checked,
    p_motivo    : $('#crMotivo').value.trim() || null
  });
  if (error){ aviso('#credMsg','bad', error.message); return; }
  await cargarCuentas();
  cargarClientes();
  aviso('#credMsg','ok', data?.mensaje ?? 'El crédito quedó fijado.');
};
